export function CookiesPage() {
  return (
    <article className="legal-document">
      <h1>Política de Cookies e Tecnologias de Armazenamento Local</h1>
      <p className="text-muted">
        LONDON SIM GESTÃO DE DOCUMENTOS LTDA (Datasci Editora) — CNPJ 22.390.588/0001-70
      </p>

      <section>
        <h2>1. Princípio da Minimização de Dados</h2>
        <p>
          A <strong>Datasci Editora</strong> opera sob uma rigorosa política de privacidade e soberania do usuário. Não
          utilizamos cookies de rastreamento comercial invasivo, não vendemos dados comportamentais a redes de anúncios nem
          carregamos bibliotecas de terceiros que monitorem sua navegação fora de nosso domínio.
        </p>
      </section>

      <section>
        <h2>2. Cookies Estritamente Necessários Utilizados</h2>
        <p>
          A plataforma utiliza exclusivamente cookies técnicos essenciais para o funcionamento seguro das sessões e proteção contra
          ataques cibernéticos:
        </p>
        <table className="data-table" style={{ margin: "var(--space-4) 0" }}>
          <thead>
            <tr>
              <th>Nome do Cookie</th>
              <th>Propósito</th>
              <th>Validade</th>
              <th>Segurança</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>datasci_session</code></td>
              <td>Manutenção da sessão de usuário autenticado (leitor individual, tenant ou admin)</td>
              <td>Duração da sessão ativa</td>
              <td>HttpOnly, Secure, SameSite=Lax</td>
            </tr>
            <tr>
              <td><code>datasci_csrf</code></td>
              <td>Token antifalsificação de requisições maliciosas (CSRF Token)</td>
              <td>Duração da sessão</td>
              <td>Secure, SameSite=Strict</td>
            </tr>
            <tr>
              <td><code>datasci_cart</code></td>
              <td>Identificador anônimo temporário para preservação dos itens no carrinho de compras</td>
              <td>7 dias</td>
              <td>HttpOnly, Secure, SameSite=Lax</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>3. Ausência de Cookies de Terceiros e Rastreamento Invasivo</h2>
        <p>
          Não carregamos pixels do Facebook/Meta, Google Analytics invasivo ou ferramentas de mapa de calor de terceiros.
          Quaisquer métricas operacionais coletadas são agregadas diretamente na camada de rede (Cloudflare Analytics server-side),
          sempre sem identificação individualizada do usuário.
        </p>
      </section>

      <section>
        <h2>4. Gestão de Cookies no Navegador</h2>
        <p>
          Você pode configurar ou bloquear cookies nas opções de preferências do seu navegador web. Contudo, note que a desativação
          dos cookies estritamente necessários impedirá a realização de login na plataforma, o salvamento do carrinho e a conclusão
          de pedidos via Pix.
        </p>
      </section>
    </article>
  );
}
